<template>
    <span class="treatment-status" :class="status">
        {{ $translate(status) }}
    </span>
</template>

<script>
import { TREATMENT_STATUS } from '../../../business/const'

export default {
    name: 'TreatmentStatus',
    props: {
        status: {
            type: String,
            required: true,
            validator: value => {
                return !!TREATMENT_STATUS[value]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.treatment-status {
    &.IN_PROGRESS {
        color: $light-3;
    }
    &.INACTIVE {
        color: $red;
        font-weight: var(--font-weight-bold);
    }
}
</style>
